import React from "react";
import Chip from "@mui/material/Chip";
import PhotoSizeSelectActualOutlinedIcon from "@mui/icons-material/PhotoSizeSelectActualOutlined";
import OndemandVideoOutlinedIcon from "@mui/icons-material/OndemandVideoOutlined";
import { Avatar, Grid, useMediaQuery, Box } from "@mui/material";
import { s3baseUri } from "../../config/config";

function OpenCreatePostCard({
  handleOpenSimpleBox,
  userInfo,
  handleOpenImageBox,
  handleOpenVideoBox,
}) {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <div className="s mb-2 mt-lg-0 mt-2">
      <div className="profile-cards p-3 community-card-title wealth-wallet">
        <div className="input-with-profile d-flex">
          <Grid
            container
            spacing={2}
            alignItems="center "
            sx={{
              paddingLeft: "0px !important",
              padding: "7px !important",
              paddingBottom: "0px !important",
            }}
          >
            {/* Profile image and "Create a Post" text in one line */}
            <Grid item xs={2} sm={1}>
              <Avatar
                sx={{ width: 45, height: 45 }}
                src={s3baseUri + userInfo?.profile_image}
              />
            </Grid>
            <Grid item xs={10} sm={11}>
              <div
                style={{ width: "100%" }}
                className="input-field ms-2"
                onClick={handleOpenSimpleBox}
              >
                Create a Post
              </div>
            </Grid>
          </Grid>
        </div>

        {/* Conditionally render Grid layout for mobile or larger screens */}
        <Grid container spacing={3} className="mt-3">
          <Grid
            item
            xs={6}
            sm={4}
            md={4}
            display="flex"
            justifyContent="center"
            sx={{
              paddingTop: "0px !important",
              marginLeft: isMobile ? "" : "25px !important",
            }}
          >
            <Box
              className="upload-photo"
              sx={{
                marginBottom: isMobile ? "10px" : "0",
              }}
            >
              <Chip
                sx={{ border: "none !important" }}
                onClick={handleOpenImageBox}
                label={
                  <>
                    <PhotoSizeSelectActualOutlinedIcon
                      style={{
                        color: "#000080",
                        marginRight: "10px",
                        fontSize: "26px",
                      }}
                    />
                    Photo
                  </>
                }
                variant="outlined"
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sm={4}
            md={4}
            display="flex"
            justifyContent="center"
            sx={{ paddingTop: "0px !important" }}
          >
            <Box
              className="upload-video"
              sx={{
                marginBottom: isMobile ? "10px" : "0",
              }}
            >
              <Chip
                sx={{ border: "none !important" }}
                onClick={handleOpenVideoBox}
                label={
                  <>
                    <OndemandVideoOutlinedIcon
                      style={{
                        color: "#000080",
                        marginRight: "10px",
                        fontSize: "26px",
                      }}
                    />
                    Video
                  </>
                }
                variant="outlined"
              />
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default OpenCreatePostCard;
